var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect, useMemo, useCallback } from 'react';
import * as paths from '../../Header/constants/paths';
import { TAppVersion } from '../../Header/types/common';
export var useVersion = function (initialVersion, initialStand) {
    if (initialVersion === void 0) { initialVersion = ''; }
    var _a = __read(useState(initialVersion), 2), version = _a[0], setVersion = _a[1];
    var _b = __read(useState(initialStand), 2), stand = _b[0], setStand = _b[1];
    var setStandVersion = useCallback(function (stand, version) {
        if ((stand === null || stand === void 0 ? void 0 : stand.toLowerCase()) === 'prod')
            return setStand(TAppVersion.PROD);
        if (version.toLowerCase() === 'dev')
            return setStand(TAppVersion.DEV);
        setStand(TAppVersion.STAGE);
    }, []);
    useEffect(function () {
        if (version && stand)
            return;
        fetch(paths.VERSION)
            .then(function (result) {
            if (!result.ok)
                throw Error(result.statusText);
            return result.json();
        })
            .then(function (_a) {
            var version = _a.version, stand = _a.stand;
            setVersion(version);
            setStandVersion(stand, version);
        })
            .catch(console.error);
    }, [setStandVersion, version]);
    return useMemo(function () { return ({
        version: version,
        stand: stand,
    }); }, [version, stand]);
};
//# sourceMappingURL=useVersion.js.map